const loadJS = () => {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://wchat.freshchat.com/js/widget.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    })
}
function initFreshChatBot() {
    const customerService = window.settings.customerService
    const freshChat = customerService && customerService.freshChat
    const token = freshChat && freshChat.hashKey
    const enableFreshChat = freshChat && freshChat.enableFreshChat
    if (enableFreshChat && token) {
        loadJS()
            .then(
                function () {
                    window.fcWidget.init({
                        token: token,
                        host: "https://wchat.freshchat.com"
                    });
                })
    }
}
export default initFreshChatBot;